<template>
  <div class="directions">
    <div class="directions__content">
      <h2>{{ title }}</h2>
      <div class="directions__list">
        <div
          v-for="advantage in advantages"
          :key="advantage.id"
          class="directions__list-item"
        >
          <VIconMTS
            :name="'faq/' + advantage.iconName"
            width="60"
            height="60"
          />
          <h3>{{ advantage.title }}</h3>
          <p v-html="advantage.text"></p>
        </div>
        <div class="statistics-card">
          <div class="statistics-card__item">
            <span>92%</span>
            <p>удовлетворённость пользователей техподдержкой МТС&nbsp;Линк</p>
          </div>
          <div class="statistics-card__item">
            <span>80%</span>
            <p>вопросов решаем при&nbsp;первом&nbsp;обращении</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VIconMTS from '@/components/Common/MTS/VIconMTS.vue'
import FaqAndSupportAdvantageListMixin from '@/components/Desktop/FaqAndSupport/mixins/FaqAndSupportAdvantageListMixin'

export default {
  name: 'FaqAndSupportDirectionsDesktop',
  components: { VIconMTS },
  mixins: [FaqAndSupportAdvantageListMixin],
}
</script>

<style scoped lang="scss">
.directions {
  padding: 64px 0 32px;

  &__content {
    display: flex;
    flex-direction: column;
    padding: 56px 32px;
    border-radius: 24px;
    background-color: $color-white;
  }

  h2 {
    font-family: $font-mts-wide;
    font-size: 36px;
    line-height: 40px;
    font-weight: 500;
    letter-spacing: -0.01em;
    text-align: center;
  }

  &__list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px 16px;
    max-width: 1128px;
    margin: 56px auto 0;
  }

  &__list-item {
    padding: 24px;

    h3 {
      font-family: $font-mts-wide;
      font-size: 24px;
      line-height: 30px;
      font-weight: 500;
      letter-spacing: -0.01em;
      margin: 12px 0 16px;
    }
  }

  &__list-item p,
  .statistics-card p {
    font-family: $font-mts-compact;
    font-size: 20px;
    line-height: 27px;
  }

  .statistics-card {
    grid-column: 1;
    grid-row: 2;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    padding: 24px;
    border-radius: 24px;
    background-color: #f6eeff;

    &__item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;

      span {
        font-family: $font-mts-wide;
        font-size: 44px;
        line-height: 44px;
        font-weight: 500;
        color: $color-purple-2;

        @include screen-down('lg') {
          font-size: 36px;
          line-height: 36px;
        }
      }

      p {
        max-width: 394px;
      }
    }
  }
}
</style>
